import {Toast, ToastContainer} from 'react-bootstrap';
import {observable} from "@legendapp/state";
import {observer} from "@legendapp/state/react";

enum ToastType {
    SUCCESS = 'primary',
    INFO = 'secondary',
    ERROR = 'danger'
}
const DefaultToastDuration = 8000;

const $toast = observable({
    type: ToastType.SUCCESS,
    show: false,
    message: '' as string | JSX.Element,
    title: undefined as string | undefined,
    duration: DefaultToastDuration,
});

const TitleByType = {
    [ToastType.SUCCESS]: '🌟 Sucesso',
    [ToastType.ERROR]: '❌ Erro',
    [ToastType.INFO]: '💡 Informação',
}

export const ToastProvider = observer(() => {
    const {message, show, type, duration, title: _title} = $toast.get();
    const hide = () => $toast.assign({show: false});
    const title = _title || TitleByType[type];

    return (
        <ToastContainer className="p-3 position-fixed" position='top-end'>
            <Toast animation
                   autohide
                   bg={type}
                   delay={duration}
                   show={show}
                   onClose={hide}
            >
                <Toast.Header closeVariant='white'>
                    <strong className="me-auto">{title}</strong>
                </Toast.Header>
                <Toast.Body>
                    {message}
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
});

export const toast = (message: string | JSX.Element, title?: string, type?: ToastType, duration: number = DefaultToastDuration) => {
    if (!message) {
        message = '-';
    }
    $toast.assign({type: type || ToastType.SUCCESS, show: true, message, title});
}

export const toastSuccess = (message: string | JSX.Element, title?: string, duration?: number) => toast(message, title, ToastType.SUCCESS, duration);
export const toastError = (message: string | JSX.Element, title?: string, duration?: number) => toast(message, title, ToastType.ERROR, duration);
export const toastInfo = (message: string | JSX.Element, title?: string, duration?: number) => toast(message, title, ToastType.INFO, duration);
